import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
    create_delivery_note_product: { status: "idle" },
};

export const create_delivery_note_product_Slice = createSlice({
    name: "create_delivery_note_product",
    initialState,
    reducers: {
        success_create_delivery_note_product: (state, action) => {
            state.create_delivery_note_product = { status: app_consts.SUCCESS, data: action.payload };
        },
        fail_create_delivery_note_product: (state, action) => {
            state.create_delivery_note_product = { status: app_consts.FAIL, message: action.payload };
        },
        reset_create_delivery_note_product: (state) => {
            state.create_delivery_note_product = { status: app_consts.IDLE };
        },
        loading_create_delivery_note_product: (state) => {
            state.create_delivery_note_product = { status: app_consts.LOADING };
        },
    }
});

export const { success_create_delivery_note_product, fail_create_delivery_note_product, reset_create_delivery_note_product, loading_create_delivery_note_product } = create_delivery_note_product_Slice.actions;

export default create_delivery_note_product_Slice.reducer;